import { render, staticRenderFns } from "./inspecciones-seguridad.vue?vue&type=template&id=11606a8a&scoped=true&"
import script from "./inspecciones-seguridad.vue?vue&type=script&lang=js&"
export * from "./inspecciones-seguridad.vue?vue&type=script&lang=js&"
import style0 from "./inspecciones-seguridad.vue?vue&type=style&index=0&id=11606a8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11606a8a",
  null
  
)

export default component.exports